module.exports = __webpack_public_path__ + "img/No Safety Catch.0be236e3.png";